import { Logger, ModuleFetcher } from '@wix/thunderbolt-becky-types'
import type { BeckyFunctionLibrary } from '@wix/thunderbolt-becky-root'

type ModulesMap = Array<{ id: string; url: string }>

export const fetchModules = async (
	model: ModulesMap,
	{
		runAsyncAndReport,
		moduleFetcher,
	}: { runAsyncAndReport: BeckyFunctionLibrary['runAsyncAndReport']; moduleFetcher: ModuleFetcher },
	logger: Logger
) => {
	const loadedModules = await Promise.all(
		model.map(async ({ id, url }) => {
			try {
				const payload: Record<string, any> = await runAsyncAndReport(
					() =>
						moduleFetcher.fetch({
							fromUrl: url,
						}),
					`fetch-module-${id}-${url}`
				)
				return { id, payload }
			} catch (error) {
				logger.error('failed loading css config module', { id, url, error: error.toString() })
				return { id, payload: {} }
			}
		})
	)
	return loadedModules.reduce<Record<string, any>>(
		(result, { id, payload }) => ({
			...result,
			[id]: payload,
		}),
		{}
	)
}
